import ReactQuill from 'react-quill';
import { useLayoutEffect, useRef } from 'react';
import 'react-quill/dist/quill.snow.css';
import {Grid} from "@mui/material"; // Importa o tema padrão do React Quill

/**
 * contentRevision: incrementar ao carregar HTML da API (ex.: descriptionEditorKey no edit).
 * O ReactQuill v2 ignora mudanças no prop `value`; aplicamos o HTML via API do Quill.
 */
function TextEditor({ description, setDescription, error, contentRevision = 0 }) {
    const quillRef = useRef(null);
    const descriptionRef = useRef(description);
    descriptionRef.current = description;

    useLayoutEffect(() => {
        const applyHtml = () => {
            const el = quillRef.current;
            if (!el || typeof el.getEditor !== 'function') {
                return false;
            }
            const quill = el.getEditor();
            const html = descriptionRef.current == null ? '' : String(descriptionRef.current);
            try {
                if (!html.trim()) {
                    quill.setContents([], 'silent');
                } else {
                    const delta = quill.clipboard.convert({ html });
                    quill.setContents(delta, 'silent');
                }
            } catch {
                quill.root.innerHTML = html;
            }
            return true;
        };

        if (!applyHtml()) {
            const id = requestAnimationFrame(() => {
                applyHtml();
            });
            return () => cancelAnimationFrame(id);
        }
    }, [contentRevision]);

    return (
        <Grid item xs={12} sm={12}>
            <ReactQuill
                ref={quillRef}
                theme="snow"
                defaultValue=""
                onChange={(value) => setDescription(value)}
                style={{ height: '300px', marginBottom: '1rem' }}
                placeholder="Digite aqui sua descrição..."
                modules={{
                    toolbar: [
                        [{ header: [1, 2, false] }],
                        ['bold', 'italic', 'underline', 'strike'], // Estilização básica
                        [{ list: 'ordered' }, { list: 'bullet' }],
                        ['link'], // Links
                        ['clean'], // Remove formatação
                    ],
                }}
                formats={[
                    'header',
                    'bold',
                    'italic',
                    'underline',
                    'strike',
                    'list',
                    'bullet',
                    'link',
                ]}
            />
            {error && (
                <div
                    className="text-danger mt-1"
                    style={{ whiteSpace: 'pre-wrap', fontSize: '0.9rem' }}
                >
                    {error}
                </div>
            )}
        </Grid>
    );
}

export default TextEditor;
